<template>
  <form
    ref="card"
    @submit.prevent="auth(value)"
    :class="{'box-loading': loading}">
    <div v-if="!value.twofa_type">
      <h4 class="mb-3">Bem-vindo!</h4>
      <p>Faça login via SSO com seu e-mail.</p>
      <div class="form-group">
        <label>{{ $t('Email') }}</label>
        <input
          v-autofocus
          type="email"
          class="form-control"
          v-model="value.email">
        <ValidateMessage :error="validateErrors.email" />
      </div>
    </div>
    <div>
      <div class="mb-3">
        <button
          type="submit"
          class="btn btn-primary">{{ $t('Acessar') }}</button>
      </div>
      <p v-if="value.twofa_type"><a href="javascript:void(0)" @click="value.twofa_type = null">Voltar para a tela de login.</a></p>
    </div>
  </form>
</template>

<script>
import config from '../../config'
export default {
  name: 'LoginSSO',
  components: {
  },
  data () {
    return {
      value: {
        email: ''
      },
      loading: false,
      validateErrors: false
    }
  },
  metaInfo () {
    return {
      title: this.$t('Login SSO')
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    auth (value) {
      this.loading = true

      this.$store
      .dispatch('authLoginSSO', {
        ...value,
        callback_url: config.app_url + '#/auth/one-time-token',
        try_again_url: config.app_url + '#/auth'
      })
      .then(result => {
        window.location.href = result.redirect_uri
      })
      .catch((err) => {
        this.shake()
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
        this.loading = false
      })
    },
    shake () {
      this.$refs.card.classList.add('shake')
      setTimeout(() => {
        this.$refs.card.classList.remove('shake')
      }, 500)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/LoginSSO.vue